// extracted by mini-css-extract-plugin
export default {"panel":"DeleteModulePopover_panel__L9lgp"};